import { clientInstance } from '../../utils/http-client'
import { baseAPICall } from '../baseAPICall'

/**
 * Shared request body for the unified opportunities/doors API (FIR-6995).
 *
 * Every unified read is the same shape: GET `path` with `target_type` injected
 * into the query params and the caller's `AbortSignal` passed through. The
 * per-endpoint functions in `unifiedOpportunitiesApi.ts` /
 * `unifiedDoorsApi.ts` differ only by `path` and response type `T`, so they all
 * delegate here.
 */
export async function unifiedGet<T>(
  path: string,
  targetType: string,
  params: Record<string, unknown> = {},
  signal?: AbortSignal
): Promise<T> {
  return baseAPICall<T>(() =>
    clientInstance.get(path, {
      signal,
      params: { ...params, target_type: targetType },
    })
  )
}
